export default {
  titles: {
    help: 'Помощь',
    socials: 'Мы в социальных сетях',
    linkToPartners: 'партнёров',
    advice: `Полученный лимит можете потратить в магазинах наших {linkToPartners}`,
  },
  content: {
    contacts: ['Номер круглосуточного<br />Сall-центра', 'Номер круглосуточного<br />Сall-центра'],
    address: 'Узбекистан, г. Ташкент, Шайхантухурский р-н, Укчи, дом 3',
  },
  links: {
    questions: 'Часто задаваемые вопросы',
    limits: 'Подробнее о лимите',
    publicOffer: 'Публичная оферта',
  },
};
